import React from 'react';
import styles from './HandbookPersonBackgroundHeader.module.scss';
import Title from '../../Components/Title/Title';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import Image from '../../Components/Image/Image';

const HandbookPersonBackgroundHeader = ({ api }) => {
  return (
    <section id={api?.id} className={`wrapper ${styles.sectionHandbook}`}>
      <Title
        title={api.attributes.sectionTitle}
        animationData={{ animation: 'fade-up', animationDelay: '300', animationDuration: '1000', animationEasing: 'easy-in-out' }}
        type="product"
      />
      <div className={styles.sectionContainer} data-aos="fade-up" data-aos-once="false" data-aos-duration="500">
        <div className={styles.contentContainer}>
          {!!api.attributes.title && (
            <p className={styles.number}>
              {api.attributes.title}
              <span className={styles.sign}>{api.attributes.unit}</span>
            </p>
          )}
          <div className={styles.textContainer}>
            {!!api.attributes.subTitle && <h4 className={styles.subTitle}> {api.attributes.subTitle}</h4>}
            <Description api={api} type="product" />
            <Button api={api} type="btnBlack" />
          </div>
        </div>
        <Image
          animationData={{ animation: 'zoom-in', animationDuration: '1000', animationEasing: 'easy-in-out' }}
          properties={api.attributes}
          type="personSec"
        />
      </div>
    </section>
  );
};

export default HandbookPersonBackgroundHeader;
